import { apiClient } from './client';

export interface TokenResponse {
  access_token: string;
  token_type: string;
}

export interface CurrentUser {
  id: string;
  email: string;
  role: string;
  organization_id: string | null;
}

export const authApi = {
  loginEmail: (email: string, password: string) =>
    apiClient.post<TokenResponse>('/auth/login', { email, password }),
  requestCode: (phone: string) =>
    apiClient.post<{ status: string }>('/auth/request-code', { phone }),
  verifyCode: (phone: string, code: string) =>
    apiClient.post<TokenResponse>('/auth/verify-code', { phone, code }),
  me: () => apiClient.get<CurrentUser>('/auth/me'),
};
